import React, { ReactNode } from 'react';
import { TStepIcon } from '../../../services/notificationPermission';

/**
 * Address-bar icons users have to click to reach the notification setting.
 *
 * Kept local to the gate rather than added to the shared icon module, and
 * drawn with `currentColor` so they follow the surrounding text colour.
 *
 * Several are shown side by side on purpose: which one Chrome puts in the
 * address bar depends on the version and the connection (lock on https,
 * the tune sliders from Chrome 117, an info circle on http/localhost), so
 * naming just one would send users looking for an icon they do not have.
 */
const svgProps = {
  width: 18,
  height: 18,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  xmlns: 'http://www.w3.org/2000/svg',
};

const lockIcon = (
  <svg {...svgProps}>
    <rect x="4" y="10" width="16" height="11" rx="2" />
    <path d="M8 10V7a4 4 0 0 1 8 0v3" />
  </svg>
);

const tuneIcon = (
  <svg {...svgProps}>
    <line x1="3" y1="8" x2="21" y2="8" />
    <line x1="3" y1="16" x2="21" y2="16" />
    <circle cx="9" cy="8" r="2.5" />
    <circle cx="16" cy="16" r="2.5" />
  </svg>
);

const infoIcon = (
  <svg {...svgProps}>
    <circle cx="12" cy="12" r="9" />
    <line x1="12" y1="11" x2="12" y2="16" />
    <line x1="12" y1="8" x2="12" y2="8.01" />
  </svg>
);

// Firefox marks a blocked notification permission with a crossed-out speech
// bubble, not a bell, so this mirrors what actually sits in its address bar.
const blockedMessageIcon = (
  <svg {...svgProps}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    <line x1="3" y1="21" x2="21" y2="3" />
  </svg>
);

const shareIcon = (
  <svg {...svgProps}>
    <path d="M12 15V3" />
    <path d="M8 7l4-4 4 4" />
    <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7" />
  </svg>
);

export const BROWSER_STEP_ICONS: Record<TStepIcon, ReactNode> = {
  lock: lockIcon,
  tune: tuneIcon,
  info: infoIcon,
  blockedMessage: blockedMessageIcon,
  share: shareIcon,
};
